const ranger = session => session?.profile?.rangerId?.trim().toUpperCase();
const cancelled = () => Object.assign(new Error('Follow-up read cancelled.'), { code: 'ERR_CANCELED' });

export async function loadVaultRequirements({ incidents, session, currentSession, api, signal, concurrency = 4 }) {
  if (!Number.isInteger(concurrency) || concurrency < 1 || concurrency > 8) throw new Error('Invalid read concurrency.');
  const check = () => {
    const current = currentSession();
    if (signal?.aborted || !session || session.expired || !current || current.expired || current.token !== session.token ||
        current.ownerUserId !== session.ownerUserId || ranger(current) !== ranger(session)) throw cancelled();
  };
  const options = { signal, expectedSessionToken: session?.token, timeout: 15000 };
  check();
  if (!Array.isArray(incidents) || incidents.some(row => !Number.isSafeInteger(row?.id) || row.id <= 0)) throw new Error('Invalid incident list.');
  if (incidents.length === 0) return { settings: null, results: [] };
  let settings = null;
  try { const response = await api.get('/system-settings/video-requirements', options); check(); if (response.status === 200) settings = response.data; }
  catch (error) { check(); /* Preserve the existing conservative all-required fallback. */ }
  const results = new Array(incidents.length); let index = 0;
  async function worker() {
    while (index < incidents.length) {
      check(); const position = index++; const incident = incidents[position];
      try {
        const response = await api.get(`/incidents/${incident.id}`, options); check();
        if (response.status !== 200 || response.data?.id !== incident.id) throw new Error('Unconfirmed incident detail.');
        results[position] = { incident, detail: response.data };
      } catch (error) {
        check(); results[position] = { incident, detail: null, error: 'Details could not be confirmed. Open the incident or retry.' };
      }
    }
  }
  await Promise.all(Array.from({ length: Math.min(concurrency, incidents.length) }, worker));
  check(); return { settings, results };
}
